import flatten from "../../array/flatten.js";
import toArray from "../../types/to-array.js";
/**
 * createFlatMapper
 *
 * @param {Function} mapFunction map function
 * @returns {Function} mapper
 */
export default function createFlatMapper(mapFunction) {
    return (elementOrElements, ...args) => {
        if (!elementOrElements || elementOrElements.length === 0) {
            return [];
        }
        if (elementOrElements.length) {
            return flatten(toArray(elementOrElements).map((element) => mapFunction(element, ...args)));
        }
        return toArray(mapFunction(elementOrElements, ...args));
    };
}
